import { apolloClient } from '~/common/apollo'
import { action, observable, store } from '~/common/mobx.decorator'
import { notifyStore } from '~/stores'
import { GET_SETTING_QUERY, UPDATE_SETTING_MUTATION } from './care-settings.graphql'
import { includes, pickBy } from 'lodash'
import { FREQUENCY } from './care-settings.constant'

@store()
class CareSettingsStore {
	@observable settings = []

	@action
	fetchNotificationSetting = async () => {
		const response = await apolloClient.query({
			query: GET_SETTING_QUERY,
		})
		this.settings = response.data?.workerReminders
	}

	@action
	updateSetting = async (newSetting) => {
		try {
			await apolloClient.mutate({
				mutation: UPDATE_SETTING_MUTATION,
				variables: {
					id: newSetting.id,
					enabled: newSetting.enabled,
					...(includes(FREQUENCY, newSetting.frequency) && {
						frequency: newSetting.frequency,
					}),
					channels: this.formatChannelsSubmit(newSetting.channels),
				},
			})

			await notifyStore.success('Update successfully')
		} catch (error) {
			notifyStore.error(error.message)
		}
	}

	formatChannelsSubmit = (channels) => {
		return Object.keys(pickBy(channels, (channel) => channel))
	}

	formatChannelsView = (channels) => {
		return channels.reduce(
			(accumulative, currentValue) => ({
				...accumulative,
				[currentValue]: true,
			}),
			{}
		)
	}
}

export const careSettingsStore = new CareSettingsStore()
